import { Component, OnInit, EventEmitter, Input, Output, HostBinding, ElementRef, OnDestroy } from '@angular/core';
import { CastingFormatType } from '../casting-formats-sel/casting-formats-sel.component';
import { StatefulCSS } from 'src/app/model/stateful_css';

export type CastingTypeFormat =
  'as-is' | 'comma-dot' | 'space-dot' | 'dot-comma' |
  'space-comma' | 'sci' | 'sci-eng' | 'sci-pow' | 'hex' |
  'hex-hash' | 'hex-c' | 'binary' | 'binary-bytes' |
  'binary-nibbles' | 'binary-tribble' | 'binary-crumb' |
  'binary-c' | 'octal' | 'octal-c' | 'phone-p3-sp-3dash4' |
  'phone-pcc334-dashed' | 'phone-pccp3-34dashed' |
  'phone-cc334-dashed' | 'phone-0cc334-dashed' |
  'phone-0cc334-spaced' | 'phone-cc334-dotted' |
  'phone-334-dotted' | 'ssn-dashed' | 'ssn' |
  'date#Tuesday, March 4, 2345' | 'date#Tuesday, March 04, 2345' | 'date#2345-03-04' | 'date#2345/03/04' |
  'date#3/2345' | 'date#03/2345' | 'date#4-Mar-45' | 'date#03/04/05' |
  'date#04-Mar-45' | 'date#Mar-45' | 'date#Mar-2345' | 'date#March 04, 2345' |
  'date#3/4/2345' | 'date#3/04/2345' | 'date#03/04/2345' |
  'date#3/4/2345 13:30' | 'date#3/04/2345 13:30' | 'date#03/04/2345 13:30' |
  'date#3/4/2345 1:30 PM' | 'date#3/04/2345 1:30 PM' | 'date#03/04/2345 1:30 PM' |
  'date#3/4/2345 01:30 PM' | 'date#3/04/2345 01:30 PM' | 'date#03/04/2345 01:30 PM' |
  'date#M' | 'date#M-45' | 'date#4-Mar-2345' |
  'date#01:30 PM' | 'date#1:30 PM' | 'date#13:30' | 'zip' | 'zip4' |
  'date#Julian:62' | 'date#Julian:062' | 'date#Julian:2345062' | 'date#Julian:45062'


@Component({
  selector: 'app-casting-type-formats-sel',
  templateUrl: './casting-type-formats-sel.component.html',
  styleUrls: ['./casting-type-formats-sel.component.scss']
})
export class CastingTypeFormatsSelComponent implements OnInit, OnDestroy {
  public typeReady = false;
  public _val: CastingTypeFormat = 'comma-dot';
  public type: CastingFormatType = 'number-general';
  public stateManager: StatefulCSS = new StatefulCSS();
  public initialClass = '';
  private _destroyed = false;
  @Input('show')
  public set show(type: CastingFormatType) {
    this.typeReady = false;
    if (this.type !== type) {
      this.UpdateFormats(type);
      this.type = type;
    }
  }

  @Input('value')
  set value(val: CastingTypeFormat) {
    if (this._destroyed === true) {
      return;
    }
    if (this._val !== val) {
      this._val = val;
      this.valueChange.emit(val);
    }
  }
  get value(): CastingTypeFormat {
    return this._val;
  }
  @Output()
  public valueChange = new EventEmitter<CastingTypeFormat>();

  @Input()
  public label = '';
  @Output()
  public labelChange = new EventEmitter<string>();


  @HostBinding('class') componentClass = '';
  constructor(private domNode: ElementRef) { }

  ngOnInit(): void {
    this.stateManager.AddState('general');
    this.stateManager.AddState('sci');
    this.stateManager.AddState('hex');
    this.stateManager.AddState('binary');
    this.stateManager.AddState('octal');
    this.stateManager.AddState('phone');
    this.stateManager.AddState('ssn');
    this.stateManager.AddState('date');
    this.stateManager.AddState('date-time');
    this.stateManager.AddState('time');
    this.stateManager.AddState('zip');
    this.stateManager.AddState('zip4');
    this.stateManager.SetMachine(this.domNode.nativeElement);
    this.initialClass = this.componentClass;
    this.UpdateFormats(this.type);
  }
  SetFormat(format: string) {
    this.stateManager.SetState(format)

  }
  UpdateFormats(type: CastingFormatType) {
    if (!this.stateManager) {
      return;
    }
    if (this._destroyed === true) {
      return;
    }
    this.typeReady = false;
    window.requestAnimationFrame(() => {
      this.label = '';
      switch (type) {
        case 'date':
          this.SetFormat('date');
          this.label = 'Date Formats';
          break;
        case 'time':
          this.SetFormat('time');
          this.label = 'Time Formats';
          break;
        case 'link':
          this.SetFormat('hidden');
          break;
        case 'number-binary':
          this.SetFormat('binary');
          this.label = 'Binary Formats';
          break;
        case 'number-currency':
        case 'number-general':
        case 'number-dec':
          this.SetFormat('general');
          this.label = 'General Number Formats:';
          break;
        case 'number-fraction':
          this.SetFormat('hidden');
          break;
        case 'number-hex':
          this.SetFormat('hex');
          this.label = 'Hexadecimal Number Formats:';
          break;
        case 'number-octal':
          this.SetFormat('octal');
          this.label = 'Octal Number Formats:';
          break;
        case 'number-percentage':
          this.SetFormat('hidden');
          break;
        case 'number-phone':
          this.SetFormat('phone');
          this.label = 'Phone Number Formats:';
          break;
        case 'number-sci':
          this.SetFormat('sci');
          this.label = 'Scientific Notation Formats:';
          break;
        case 'number-zipcode':
          this.SetFormat('zip');
          this.label = 'Zipcode Formats:';
          break;
      }
      this.labelChange.emit(this.label);
      this.typeReady = true;
      const options = $('[data-start="' + this.stateManager.GetCurrentState() + '"', this.domNode.nativeElement);
      const firstOption = $('.req-' + type, this.domNode.nativeElement)[0];
      if (!!firstOption) {
        this.value = $(firstOption).attr('value') as CastingTypeFormat;

      }

    });
  }
  ngOnDestroy() {
    this._destroyed = true;
  }
}
